import React from 'react';
import { Box } from '@hz-design-system/web-ui';
import { ListingDescription, ListingTitle } from '@/client/components/ListingsNew/components';

import Classes from './ListingTitleDescription.module.scss';

interface ListingTitleDescriptionProps {
  title: string;
  description: string;
}

const ListingTitleDescription: React.FC<ListingTitleDescriptionProps> = ({ title, description }) => {
  return (
    <Box as="div" name="title-description" className={Classes['hz-Listing-title-description']}>
      <ListingTitle.Large title={title} strong={true} />
      <ListingDescription.Regular description={description} />
    </Box>
  );
};

export default ListingTitleDescription;
